import { createAction } from 'redux-actions';

export const resetVisitHistory = createAction('RESET_VISIT_HISTORY');

export const visitsHistoryOnChangePage = createAction(
  'VISIT_HISTORY_ON_CHANGE_PAGE'
);

export const visitsHistoryOnChangeOrder = createAction(
  'VISIT_HISTORY_ON_CHANGE_ORDER'
);

export const visitsHistoryOnChangeLimit = createAction(
  'VISIT_HISTORY_ON_CHANGE_Limit'
);
